import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {b, v} from "../styles/variables";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { MobileHide, TabletHide } from "../styles/globalStyles";
import {useSelector} from 'react-redux';
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getUserInfo } from "../redux/feature/authSlice";
import Loader from "./Loader";
import { ModalProvider, BaseModalBackground } from "styled-react-modal";
import MyLocation from "./MyLocation/Index";
import { getTotals } from "../redux/feature/cartSlice";
import { sideBarOff } from "../redux/feature/uiSlice";

const RequireAuth = ({ allowedRoles }) => { 
  const dispatch = useDispatch()   
  const auth=useSelector((state) => state.auth)
  const {sidebarState} = useSelector((state) => state.ui);
  const loading=auth.isloading
  let userLocation = auth.creds.userlocation
 const location = useLocation();
 const cart=useSelector((state) => state.cart)

    return (<>{loading? <Loader/> :
    <AppContainer>
      {auth?.isAuthenticated && <SideBarContainer sidebarState={sidebarState}><Sidebar/></SideBarContainer>}
      {auth?.isAuthenticated && sidebarState && <Overlay onClick={()=>dispatch(sideBarOff())} />}
      <Main onClick={()=>{sidebarState && dispatch(sideBarOff())}}>
       {auth?.isAuthenticated && <NavBarContainer><Navbar/></NavBarContainer>}
       <ModalProvider backgroundComponent={FadingBackground}>
        <BodyContainer> {         
         auth?.isAuthenticated
            ? (auth?.creds?.roleslist?.find(role => allowedRoles?.includes(role))? 
            (userLocation === "" ? <MyLocation/> : <Outlet/>) :
            <Navigate to="/unauthorized" state={{ from: location }} replace />) :            
             <Navigate to="/login" state={{ from: location }} replace />}
            </BodyContainer>
            </ModalProvider>
      
          </Main>
       </AppContainer>       
      } </>);
}

export default RequireAuth;

const AppContainer = styled.div`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  font-family: 'Nunito Sans', sans-serif;
  background: #f8f9fb;
  overflow-x: hidden;
`

const Main = styled.div`  
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 250px;
  display: flex;
  flex-direction: column;
  
  @media ${b.mobile}{
    left: 0;
  }
`

const SideBarContainer = styled.div`
  background: ${({theme})=>theme.bg};
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 250px;
  z-index: 1000;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);

  @media ${b.mobile}{
    display: ${({sidebarState})=>sidebarState? 'block' : 'none'};
    width: 280px;
  }
`;

const Overlay = styled.div`
  display: none;
  
  @media ${b.mobile}{
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;
  }
`;

const NavBarContainer = styled.nav`
  display: flex;
  background: #ffffff;
  height: 64px;
  border-bottom: 1px solid #e4e4e7;
  flex-shrink: 0;
`;

const BodyContainer = styled.div`
  width: 100%;
  flex: 1;
  overflow-y: auto;
  background: #f8f9fb;
  
  @media ${b.mobile}{
    padding: 0;
  }
`;

const FadingBackground = styled(BaseModalBackground)`
  opacity: ${(props) => props.opacity};
  transition: all 0.3s ease-in-out;
`;
